const resetApp = () => {
	// console.log('Reset app');
	// localStorage.clear();
	localStorage.removeItem("redux");
	// window.location.reload();
	window.location.href = '/';
};
export default resetApp;
